import { Injectable, resource } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { BatchJobType } from './batch-job-type.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobTypeDatasource extends RestDatasource<BatchJobType> {
  override endpoint = '/api/admin/batchjobtyper';

  data = resource({
    loader: async ({ abortSignal }) => {
      return await this.getList(
        {
          sortBy: 'navn',
        },
        abortSignal
      );
    },
  });
}
